import React, { Fragment, useEffect, useState } from 'react';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Bg from '../../images/bg/page_bg01.jpg'
import icon from '../../images/icon/magic.svg'
import gImg1 from '../../images/gallery/cp-img01.png'
import gImg2 from '../../images/gallery/cp-img02.png'
import gImg3 from '../../images/gallery/cp-img033.png'
import gImg4 from '../../images/gallery/cp-img04.png'
import gImg5 from '../../images/gallery/cp-img05.png'
import gImg6 from '../../images/gallery/cp-img06.png'
import Footer from '../../components/data-solutions-components/Footer/Footer';
import DataSolutionFaqSection from '../../components/data-solutions-components/DataSolutionFaqSection/DataSolutionFaqSection';
import { useParams } from 'react-router-dom';
import parse from 'html-react-parser';
import Loader from '../../components/Loader/Loader';
import ReCAPTCHA from "react-google-recaptcha";
import { toast } from 'react-toastify';
const CareerSingle = (props) => {
    const params = useParams();
    const pageId = encodeURIComponent(params.id);
    const [isDisabled , setIsDisable] = useState(true)
    const [inprogress , setInprogress] = useState(false)
    const [capVal , setCapVal] = useState(null)
    var api = "https://script.google.com/macros/s/AKfycbxCU6QJL4LPPv5S8a9TXyXMVBeTi0Sc_-iJQdRxHMtixJll66Q4ZRHOnGcF-fCNpZvc1w/exec";

    const sheetApiHandler = async (formData, apiData) => {
        // setSuccessm(true);
        const createdby = new Date();
        const options = {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        };
        const formattedDate = createdby.toLocaleString('en-US', options);


        formData.CreatedDate = formattedDate;

        const fetchOptions = {
            method: 'POST',
            body: JSON.stringify(formData)
        }
        fetch(apiData, fetchOptions)
            .then(res => res.json())
            .catch(console.error)
    }
  
  
 useEffect(() => {
        if(capVal){ 
            setIsDisable(false)
        }else{
            
            setIsDisable(true)
        }
    }, [capVal])

    const SubmitHandler = async (e) => {
        e.preventDefault()
        if(capVal === null) return ;
        setIsDisable(true);
        const f = e.target.closest('form');
        const data = new FormData(f);
        const formId = f.id;
        const formRefresh = e.target;
        const formData = Object.fromEntries(data);
        formData.job_title = pageId;
        var apiData = "";
        try {
            const response = await fetch(api + "?formid=" + formId);
            if (!response.ok) {
                return;
            }

            const data = await response.json();
            if (!data || data.length === 0) {
                return;
            }

            apiData = data[0].Api_link;
            console.log("findData", apiData)
            await sheetApiHandler(formData, apiData);
            toast("Record Save Successfully")
            formRefresh.reset();
        } catch (error) {
            return;
        } finally{
            
           
            
        }

    }
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        if (pageId) {
            fetch(`https://script.google.com/macros/s/AKfycbz1pQ9fbAyaUSmVU98Q4wF8LMBfShz2-3Xcd4aSmr6e_dxVg3BHvIHuWAvoWvnzh3y-CQ/exec?jobdetail=${pageId}`)
                .then((response) => {
                    if (!response.ok) {
                        setIsError(true);
                        return;
                    }
                    return response.json();
                })
                .then((data) => {
                    // If data is empty or no valid blog found
                    if (!data || data.length === 0) {
                        setIsError(true);
                    } else {
                        setData(data[0]); // Assuming data is an array, and we take the first item
                    }
                })
                .catch((error) => {
                    console.error(error);
                    setIsError(true);
                })
                .finally(() => setIsLoading(false));
        } else {
            setIsError(true);
            setIsLoading(false);
        }
    }, [pageId]);

    // If loading data
    if (isLoading) {
        return <Loader />;
    }

    // If data is empty or error occurred
    if (isError) {
        return (<section className="container d-flex justify-content-center align-items-center" style={{ height: '100vh' }}><h1>404 - Not Found</h1></section>);
    }

    return (
        <Fragment>
            <div className='body_wrap sco_agency'>
                <Header />
                <section className="page-title cp-page-title pt-200 pos-rel bg_img" style={{ backgroundImage: `url(${Bg})` }}>
                    <div className="container">
                        <div className="page-title-wrap">
                            <div className="row mt-none-30 align-items-center">
                                <div className="col-lg-8 mt-30">
                                    <div className="page-title-box">
                                        <span className="sub-title"><img src={icon} alt="" />Careers</span>
                                        <h2 className="title">Find the Right Role for You at <br />TechStr</h2>
                                    </div>
                                </div>
                                <div className="col-lg-4 mt-30">
                                    <div className="cp-img-slide">
                                        <div className="cp-img-inner ul_li">
                                            <div className="cp-item marquee-first">
                                                <div className="xb-img"><img src={gImg1} alt="" /></div>
                                                <div className="xb-img"><img src={gImg2} alt="" /></div>
                                                <div className="xb-img"><img src={gImg3} alt="" /></div>
                                                <div className="xb-img"><img src={gImg1} alt="" /></div>
                                                <div className="xb-img"><img src={gImg2} alt="" /></div>
                                                <div className="xb-img"><img src={gImg3} alt="" /></div>
                                            </div>
                                            <div className="cp-item marquee-2">
                                                <div className="xb-img"><img src={gImg4} alt="" /></div>
                                                <div className="xb-img"><img src={gImg5} alt="" /></div>
                                                <div className="xb-img"><img src={gImg6} alt="" /></div>
                                                <div className="xb-img"><img src={gImg4} alt="" /></div>
                                                <div className="xb-img"><img src={gImg5} alt="" /></div>
                                                <div className="xb-img"><img src={gImg6} alt="" /></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="cp-det-bg">
                    <section className="career-details">
                        <div className="container">
                            <div className="cp-details-wrap">

                                {data && Object.entries(data).map(([key, value]) => (
                                    <div
                                        key={key}
                                        className="xb-details-item"

                                    >
                                        {value == pageId ? "" : parse(value)}
                                    </div>
                                ))}
                                {/* <div className="xb-details-item">
                                    <h3 className="xb-item--title">What you'll get to do...</h3>
                                    <ul className="xb-details-content">
                                        <li>6+ years of previous professional Proficient Project Management experience.</li>
                                        <li><span>Technical Expertise:</span> Solid understanding for effective communication.</li>
                                        <li><span>Stakeholder Management:</span> Track record of ensuring alignment and success.</li>
                                        <li><span>Agile Methodologies:</span> Hands-on experience in Agile frameworks.</li>
                                        <li><span>Risk Management:</span> Skill in identifying and mitigating project risks.</li>
                                        <li> <span>Team Leadership:</span> Ability to motivate diverse teams.</li>
                                        <li><span>Communication Skills:</span> Strong ability to convey technical concepts.</li>
                                        <li><span>Problem-Solving:</span> Proactive approach to implement solutions.</li>
                                        <li><span>Quality Assurance:</span> Experience in ensuring deliverable standards.</li>
                                    </ul>
                                </div>
                                <div className="xb-details-item">
                                    <h3 className="xb-item--title">You might also have...</h3>
                                    <ul className="xb-details-content">
                                        <li>Experience with AWS.</li>
                                        <li>Experience building CI/CD and server/deployment automation solutions</li>
                                        <li>Experience with open-source puppet, infrastructure-as-code.</li>
                                        <li>Passion for technology.</li>
                                        <li>You have high standards and want to make a difference with your work.</li>
                                        <li>You are always trying to improve.</li>
                                    </ul>
                                </div>*/}

                            </div>
                        </div>
                    </section>
                    <div className="cp-contact-wrap pt-130 pb-130">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="cs-contact-wrap cs-contact-form cd-contact-form">
                                        <h2 className="xb-title">Apply for this job</h2>
                                        <p className="xb-content">innomax doesn’t accept unsolicited resumes from recruiters or employment agencies.</p>
                                        <form onSubmit={SubmitHandler} className="contact-form" id='jobDetailsForm'>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="input-field">
                                                        <label htmlFor="text1">Name*</label>
                                                        <div className="input-box">
                                                            <input type="text" name="name" id="text1" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="input-field">
                                                        <label htmlFor="text2">Email*</label>
                                                        <div className="input-box">
                                                            <input type="email" name="email" id="text2" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="input-field">
                                                        <label htmlFor="text3">Phone*</label>
                                                        <div className="input-box">
                                                            <input type="tel" name="phone" id="text3" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="input-field">
                                                        <label htmlFor="text4">Address*</label>
                                                        <div className="input-box">
                                                            <input type="text" name="address" id="text4" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="input-field text-field">
                                                        <label htmlFor="text5">Cover Letter</label>
                                                        <div className="input-box">
                                                            <textarea name="message" id="text5"></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="cp-contact-bottom ul_li_between mt-20">
                                                <div className="xb-item--left mt-20">
                                                    <ReCAPTCHA
                                                        sitekey="6LcaZP4qAAAAAJXeYiPXz-MaQdEoLC9Tw07VBrv1"
                                                        onChange={(val) => setCapVal(val)}
                                                        className="custom-recaptcha-class"
                                                        theme="light"
                                                    />
                                                    {/* <label htmlFor="file">Upload your resume / CV</label>
                                                    <input id="file" type="file" required />
                                                    <p className="xb-item--content"><span>Accepted file types :</span> pdf, doc, jpg, Max. file size: 15 MB.</p> */}
                                                </div>
                                                <div className="cp-det-btn mt-20">
                                                    <button className="cp-btn" disabled={isDisabled}>Submit now <i className="fal fa-arrow-right"></i></button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <DataSolutionFaqSection />
            </div>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default CareerSingle;
